<div class="Block">
  <input type='file' (change)="fileChanged($event)">
</div>